<section class="breadcrumb">
    <ng-container *ngFor="let item of breadcrumb; let i = index">
        <span (click)="goToRoute(item.link)" [class.linked]="item.link.length" [class.active]="i === (breadcrumb.length - 1)">
            {{item.name}}
        </span>
        <mat-icon *ngIf="i < (breadcrumb.length - 1)">chevron_right</mat-icon>
    </ng-container>
</section>